"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e="0.33.8";exports.version=e;
